import React, { Fragment, useState, useEffect } from 'react';
import {
    Row,
    FormGroup,
    Label,
    Col,
    Card,
    CardBody,
    UncontrolledDropdown,
    DropdownItem,
    DropdownToggle,
    DropdownMenu,
    Spinner,
    Modal, ModalHeader,
    ModalBody, ModalFooter, Button
} from 'reactstrap';
import Axios from 'axios';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import {
    week,
    month,
    last7Days,
    last30Days,
    last60Days,
    last90Days,
    LastDays,
    year,
} from './lablesConfig';
import {
    gAPI_SpaceClick_Stats,
    gAPI_SpaceClick_DateWise_Stats,
    gAPI_SpaceAvatarClick_DateWise_Stats
} from '../../../../../constants/APIs';
import moment from 'moment';
import IntlMessages from '../../../../../helpers/IntlMessages';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import DatePicker from 'react-datepicker';
import 'moment-timezone';
import ItemClickStats from './SpaceBookingStats/ItemClickStats';
import ItemVisitsChartCard from './SpaceBookingStats/ItemVisitsChartCard';
import NumberStats from './SpaceBookingStats/NumberStats';

const dataTableSpaceStatsColumns = [
    {
        Header: <IntlMessages id='dashboards.title' />,
        accessor: 'title',
        Cell: (props) => <p className="ml-2">{props.value}</p>,
    },
    {
        Header: <IntlMessages id='dashboards.clicks' />,
        accessor: 'clicks',
        Cell: (props) => <p className="ml-3">{props.value}</p>,
    },
    {
        Header: 'Booked',
        accessor: 'booked',
        Cell: (props) => <p className="ml-3">{props.value}</p>,
    },
];

export default function SpaceBookingCard({
    propertyId,
    isVoucherEngine,
    timeZone,
    domains,
    currency,
    history,
    integrationIdList
}) {
    moment.tz.setDefault(timeZone);
    const [buttonText, setButtonText] = useState(
        <IntlMessages id="dashboards.last-7-days" />
    );
    const [labels, setLabels] = useState(last7Days);
    const [isShow, setIsShow] = useState(false);
    const [isError, setError] = useState(false);
    const [message, setMessage] = useState('');
    const [filterDate, setFilterDate] = useState(false);
    const [startDate, setStartDate] = useState(moment().subtract(15, 'days'));
    const [endDate, setEndDate] = useState(moment().subtract(1, 'days'));
    const [isVisitorVisit, setIsVisitorVisit] = useState(true);
    const [visitorVisitStatsData, setVisitorVisitStatsData] = useState([]);
    const [isItemVisitStats, setIsItemVisitStats] = useState(false);
    const [itemVisitStatsData, setItemVisitStatsData] = useState([]);
    const [isItemClickStats, setIsItemClickStats] = useState(false);
    const [itemClickData, setItemClickData] = useState([]);
    const [isTotalSpaceClicks, setIsTotalSpaceClicks] = useState(false);
    const [avatarClickData, setAvatarClickData] = useState([]);
    const [isAvatarClick, setIsAvatarClick] = useState(false);
    const [itemVisitStatsError, setItemVisitStatsError] = useState(null);
    const [itemClickStatsError, setItemClickStatsError] = useState(null);
    const [avatarClickStatsError, setAvatarClickStatsError] = useState(null);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');

    const today = () => {
        return moment(moment().subtract(1, 'days').format('YYYY-MM-DD') + ' 23:59:59')
            .utc()
            .format('YYYY-MM-DD HH:mm:ss');
    };

    const daysAgo7 = () => {
        return moment(moment().subtract(7, 'days').format('YYYY-MM-DD HH:mm:ss'))
            .utc()
            .format('YYYY-MM-DD 00:00:00');
    };

    const daysAgo30 = () => {
        return moment(moment().subtract(30, 'days').format('YYYY-MM-DD HH:mm:ss'))
            .utc()
            .format('YYYY-MM-DD 00:00:00');
    };

    const daysAgo60 = () => {
        return moment(moment().subtract(60, 'days').format('YYYY-MM-DD HH:mm:ss'))
            .utc()
            .format('YYYY-MM-DD 00:00:00');
    };

    const daysAgo90 = () => {
        return moment(moment().subtract(90, 'days').format('YYYY-MM-DD HH:mm:ss'))
            .utc()
            .format('YYYY-MM-DD 00:00:00');
    };

    const startOfWeek = () => {
        const today = moment().subtract(1, 'days');
        return moment(moment(today).isoWeekday(1).format('YYYY-MM-DD HH:mm:ss'))
            .utc()
            .format('YYYY-MM-DD 00:00:00');
    };

    const endOfWeek = () => {
        const today = moment().subtract(1, 'days');
        return moment(
            moment(today).isoWeekday(7).format('YYYY-MM-DD') + ' 23:59:59'
        )
            .utc()
            .format('YYYY-MM-DD HH:mm:ss');
    };

    const startOfMonth = () => {
        return moment(moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'))
            .utc()
            .format('YYYY-MM-DD 00:00:00');
    };

    const startOfPreviousMonth = () => {
        return moment(
            moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD') +
            ' 00:00:00'
        )
            .utc()
            .format('YYYY-MM-DD HH:mm:ss');
    };

    const startOfThisYear = () => {
        return moment(new Date().getFullYear() + '-01-01' + ' 00:00:00').format(
            'YYYY-MM-DD HH:mm:ss'
        );
    };

    const startOfLastYear = () => {
        return moment(new Date().getFullYear() - 1 + '-01-01' + ' 00:00:00').format(
            'YYYY-MM-DD HH:mm:ss'
        );
    };

    const endOfLastYear = () => {
        return moment(new Date().getFullYear() - 1 + '-12-31' + ' 00:00:00').format(
            'YYYY-MM-DD HH:mm:ss'
        );
    };

    const endOfPreviousMonth = () => {
        return moment(
            moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD') +
            ' 23:59:59'
        )
            .utc()
            .format('YYYY-MM-DD HH:mm:ss');
    };

    const endOfMonth = () => {
        return moment(moment().endOf('month').format('YYYY-MM-DD') + ' 23:59:59')
            .utc()
            .format('YYYY-MM-DD HH:mm:ss');
    };

    const handleStartDate = (date) => {
        setStartDate(moment(date))
    };

    const handleEndDate = (date) => {
        setEndDate(moment(date))
    };

    const StatContainer = ({ error, isLoading, onRefresh, children }) => {
        if (error) {
            return (
                <Card className="text-center my-3" style={{ padding: '100px' }}>
                    <p style={{ color: 'red' }}>{error}</p>
                    <i
                        className="iconsminds-refresh"
                        style={{ fontSize: '40px', color: 'grey', cursor: 'pointer' }}
                        onClick={onRefresh}
                    />
                </Card>
            );
        }

        return isLoading ? (
            <div className="text-center">
                <div className="text-center loading" />
            </div>
        ) : (
            children
        );
    };
    const fetchItemVisitStats = async (from, to) => {
        setIsItemVisitStats(true);
        setItemVisitStatsError(null);
        try {
            const res = await AxiosAPI({
                method: 'get',
                url: `${gAPI_SpaceClick_DateWise_Stats}`,
                params: {
                    groupId: getGroupID(),
                    propertyId: propertyId,
                    dateFrom: from,
                    dateTo: to,
                }
            });
            setItemVisitStatsData(res.data);
        } catch (error) {
            console.error('Item Visit Stats error:', error);
            setItemVisitStatsError('Failed to load visit stats.');
        } finally {
            setIsItemVisitStats(false);
        }
    };

    const fetchItemClickStats = async (from, to) => {
        setIsItemClickStats(true);
        setItemClickStatsError(null);
        try {
            const res = await AxiosAPI({
                method: 'get',
                url: `${gAPI_SpaceClick_Stats}`,
                params: {
                    groupId: getGroupID(),
                    propertyId: propertyId,
                    dateFrom: from,
                    dateTo: to,
                    lang: 'en'
                }
            });
            setItemClickData(res.data);
        } catch (error) {
            console.error('Item Click Stats error:', error);
            setItemClickStatsError('Failed to load click stats.');
        } finally {
            setIsItemClickStats(false);
            setIsTotalSpaceClicks(false);
        }
    };

    const fetchAvatarClickStats = async (from, to) => {
        setIsAvatarClick(true);
        setAvatarClickStatsError(null);
        try {
            const res = await AxiosAPI({
                method: 'get',
                url: `${gAPI_SpaceAvatarClick_DateWise_Stats}`,
                params: {
                    groupId: getGroupID(),
                    propertyId: propertyId,
                    dateFrom: from,
                    dateTo: to,
                }
            });
            setAvatarClickData(res.data);
        } catch (error) {
            console.error('Avatar Click Stats error:', error);
            setAvatarClickStatsError('Failed to load avatar clicks.');
        } finally {
            setIsAvatarClick(false);
        }
    };

    useEffect(() => {
        if (propertyId !== '' && propertyId !== undefined) {
            selectLast7Days();

        }
    }, [propertyId]);

    const selectLast7Days = () => {
        setFilterDate(false);
        setButtonText(<IntlMessages id="dashboards.last-7-days" />);
        setLabels(last7Days);
        const from = daysAgo7();
        const to = today();
        setFromDate(from);
        setToDate(to);
        setIsVisitorVisit(true);
        setIsTotalSpaceClicks(true);
        fetchItemVisitStats(from, to);
        fetchItemClickStats(from, to);
        fetchAvatarClickStats(from, to);
    };
    const selectLast30Days = () => {
        setFilterDate(false);
        setButtonText(<IntlMessages id="dashboards.last-30-days" />);
        setLabels(last30Days);
        const from = daysAgo30();
        const to = today();
        setFromDate(from);
        setToDate(to);
        setIsVisitorVisit(true);
        setIsTotalSpaceClicks(true);
        fetchItemVisitStats(from, to);
        fetchItemClickStats(from, to);
        fetchAvatarClickStats(from, to);
    };

    const selectLast60Days = () => {
        setFilterDate(false);
        setButtonText(<IntlMessages id="dashboards.last-60-days" />);
        setLabels(last60Days);
        const from = daysAgo60();
        const to = today();
        setFromDate(from);
        setToDate(to);
        setIsVisitorVisit(true);
        setIsTotalSpaceClicks(true);
        fetchItemVisitStats(from, to);
        fetchItemClickStats(from, to);
        fetchAvatarClickStats(from, to);
    };
    const selectLast90Days = () => {
        setFilterDate(false);
        setButtonText(<IntlMessages id="dashboards.last-90-days" />);
        setLabels(last90Days);
        const from = daysAgo90();
        const to = today();
        setFromDate(from);
        setToDate(to);
        setIsVisitorVisit(true);
        setIsTotalSpaceClicks(true);
        fetchItemVisitStats(from, to);
        fetchItemClickStats(from, to);
        fetchAvatarClickStats(from, to);
    };

    const selectThisWeek = () => {
        setFilterDate(false);
        setButtonText(<IntlMessages id="dashboards.this-week" />);
        setLabels(week);
        const from = startOfWeek();
        const to = endOfWeek();
        setFromDate(from);
        setToDate(to);
        setIsVisitorVisit(true);
        setIsTotalSpaceClicks(true);
        fetchItemVisitStats(from, to);
        fetchItemClickStats(from, to);
        fetchAvatarClickStats(from, to);
    };

    const handleFilterDateWise = (startDate, endDate) => {
        setIsVisitorVisit(true);
        setIsTotalSpaceClicks(true);
        const from = startDate;
        const to = endDate;
        setFromDate(from);
        setToDate(to);
        setIsVisitorVisit(true);
        setIsTotalSpaceClicks(true);
        fetchItemVisitStats(from, to);
        fetchItemClickStats(from, to);
        fetchAvatarClickStats(from, to);

    }

    const selectThisMonth = () => {
        setFilterDate(false);
        setButtonText(<IntlMessages id="dashboards.this-month" />);
        setLabels(month);
        const from = startOfMonth();
        const to = endOfMonth();
        setFromDate(from);
        setToDate(to);
        setIsVisitorVisit(true);
        setIsTotalSpaceClicks(true);
        fetchItemVisitStats(from, to);
        fetchItemClickStats(from, to);
        fetchAvatarClickStats(from, to);
    };
    const selectPreviousMonth = () => {
        setFilterDate(false);
        setButtonText(<IntlMessages id="dashboards.previous-month" />);
        setLabels(month);
        const from = startOfPreviousMonth();
        const to = endOfPreviousMonth();
        setFromDate(from);
        setToDate(to);
        setIsVisitorVisit(true);
        setIsTotalSpaceClicks(true);
        fetchItemVisitStats(from, to);
        fetchItemClickStats(from, to);
        fetchAvatarClickStats(from, to);
    };
    const selectThisYear = () => {
        setFilterDate(false);
        setButtonText(<IntlMessages id="dashboards.yeartodate" />);
        setLabels(year);
        const from = startOfThisYear();
        const to = today();
        setFromDate(from);
        setToDate(to);
        setIsVisitorVisit(true);
        setIsTotalSpaceClicks(true);
        fetchItemVisitStats(from, to);
        fetchItemClickStats(from, to);
        fetchAvatarClickStats(from, to);
    };
    const selectLastYear = () => {
        setFilterDate(false);
        setButtonText(<IntlMessages id="dashboards.lastyear" />);
        setLabels(year);
        const from = startOfLastYear();
        const to = endOfLastYear();
        setFromDate(from);
        setToDate(to);
        setIsVisitorVisit(true);
        setIsTotalSpaceClicks(true);
        fetchItemVisitStats(from, to);
        fetchItemClickStats(from, to);
        fetchAvatarClickStats(from, to);
    };
    const handleFilterMonthWise = (startDate, endDate) => {
        const from = startDate;
        const to = endDate;
        setLabels(year);
        setFromDate(from);
        setToDate(to);
        setIsVisitorVisit(true);
        setIsTotalSpaceClicks(true);

        fetchItemVisitStats(from, to);
        fetchItemClickStats(from, to);
        fetchAvatarClickStats(from, to);
    }
    // const selectLast7Days = () => {
    //     setFilterDate(false);
    //     setButtonText(<IntlMessages id="dashboards.last-7-days" />);
    //     setLabels(last7Days);
    //     setIsVisitorVisit(true);
    //     setIsItemVisitStats(true);
    //     setIsItemClickStats(true);
    //     setIsTotalSpaceClicks(true);
    //     setIsAvatarClick(true);
    //     Axios.all([
    //         AxiosAPI({
    //             method: 'get',
    //             url: `${gAPI_SpaceClick_DateWise_Stats}`,
    //             params: {
    //                 groupId: getGroupID(),
    //                 propertyId: propertyId,
    //                 dateFrom: daysAgo7(),
    //                 dateTo: today(),
    //             },
    //         }).then((res) => {
    //             setItemVisitStatsData(res.data);
    //             setIsItemVisitStats(false);
    //         }),
    //         AxiosAPI({
    //             method: 'get',
    //             url: `${gAPI_SpaceClick_Stats}`,
    //             params: {
    //                 groupId: getGroupID(),
    //                 propertyId: propertyId,
    //                 dateFrom: daysAgo7(),
    //                 dateTo: today(),
    //                 lang: "en"
    //             },
    //         }).then((res) => {
    //             setItemClickData(res.data);
    //             setIsItemClickStats(false);
    //             setIsTotalSpaceClicks(false);
    //         }),
    //         AxiosAPI({
    //             method: 'get',
    //             url: `${gAPI_SpaceAvatarClick_DateWise_Stats}`,
    //             params: {
    //                 groupId: getGroupID(),
    //                 propertyId: propertyId,
    //                 dateFrom: daysAgo7(),
    //                 dateTo: today(),
    //             },
    //         }).then((res) => {
    //             setAvatarClickData(res.data);
    //             setIsAvatarClick(false);
    //         }),
    //     ]);
    // };

    // const selectLast30Days = () => {
    //     setFilterDate(false);
    //     setButtonText(<IntlMessages id="dashboards.last-30-days" />);
    //     setLabels(last30Days);
    //     setIsVisitorVisit(true);
    //     setIsItemVisitStats(true);
    //     setIsItemClickStats(true);
    //     setIsTotalSpaceClicks(true);
    //     setIsAvatarClick(true);
    //     Axios.all([
    //         AxiosAPI({
    //             method: 'get',
    //             url: `${gAPI_SpaceClick_DateWise_Stats}`,
    //             params: {
    //                 groupId: getGroupID(),
    //                 propertyId: propertyId,
    //                 dateFrom: daysAgo30(),
    //                 dateTo: today(),
    //             },
    //         }).then((res) => {
    //             setItemVisitStatsData(res.data);
    //             setIsItemVisitStats(false);
    //         }),
    //         AxiosAPI({
    //             method: 'get',
    //             url: `${gAPI_SpaceClick_Stats}`,
    //             params: {
    //                 groupId: getGroupID(),
    //                 propertyId: propertyId,
    //                 dateFrom: daysAgo30(),
    //                 dateTo: today(),
    //                 lang: "en"
    //             },
    //         }).then((res) => {
    //             setItemClickData(res.data);
    //             setIsItemClickStats(false);
    //             setIsTotalSpaceClicks(false);
    //         }),
    //         AxiosAPI({
    //             method: 'get',
    //             url: `${gAPI_SpaceAvatarClick_DateWise_Stats}`,
    //             params: {
    //                 groupId: getGroupID(),
    //                 propertyId: propertyId,
    //                 dateFrom: daysAgo30(),
    //                 dateTo: today(),
    //             },
    //         }).then((res) => {
    //             setAvatarClickData(res.data);
    //             setIsAvatarClick(false);
    //         }),
    //     ]);
    // };
    // const selectLast60Days = () => {
    //     setButtonText(<IntlMessages id="dashboards.last-60-days" />);
    //     setLabels(last60Days);
    //     setFilterDate(false);
    //     setIsVisitorVisit(true);
    //     setIsItemVisitStats(true);
    //     setIsItemClickStats(true);
    //     setIsTotalSpaceClicks(true);
    //     setIsAvatarClick(true);
    //     Axios.all([
    //         // AxiosAPI({
    //         //     method: 'post',
    //         //     url: `${gAPI_VisitorsGroups_Stats}`,
    //         //     data: {
    //         //         groupId: getGroupID(),
    //         //         dateFrom: daysAgo60(),
    //         //         dateTo: today(),
    //         //         propertyId: propertyId === "-1" ? null : propertyId,
    //         //         integrationId: integrationIdList
    //         //     },
    //         // }).then((res) => {
    //         //     setVisitorVisitStatsData(res.data);
    //         //     setIsVisitorVisit(false);
    //         // }),
    //         AxiosAPI({
    //             method: 'get',
    //             url: `${gAPI_SpaceClick_DateWise_Stats}`,
    //             params: {
    //                 groupId: getGroupID(),
    //                 propertyId: propertyId,
    //                 dateFrom: daysAgo60(),
    //                 dateTo: today(),
    //             },
    //         }).then((res) => {
    //             setItemVisitStatsData(res.data);
    //             setIsItemVisitStats(false);
    //         }),
    //         AxiosAPI({
    //             method: 'get',
    //             url: `${gAPI_SpaceClick_Stats}`,
    //             params: {
    //                 groupId: getGroupID(),
    //                 propertyId: propertyId,
    //                 dateFrom: daysAgo60(),
    //                 dateTo: today(),
    //                 lang: "en"
    //             },
    //         }).then((res) => {
    //             setItemClickData(res.data);
    //             setIsItemClickStats(false);
    //             setIsTotalSpaceClicks(false);
    //         }),
    //         AxiosAPI({
    //             method: 'get',
    //             url: `${gAPI_SpaceAvatarClick_DateWise_Stats}`,
    //             params: {
    //                 groupId: getGroupID(),
    //                 propertyId: propertyId,
    //                 dateFrom: daysAgo60(),
    //                 dateTo: today(),
    //             },
    //         }).then((res) => {
    //             setAvatarClickData(res.data);
    //             setIsAvatarClick(false);
    //         }),
    //     ]);
    // };
    // const selectLast90Days = () => {
    //     setFilterDate(false);
    //     setButtonText(<IntlMessages id="dashboards.last-90-days" />);
    //     setLabels(last90Days);
    //     setIsVisitorVisit(true);
    //     setIsItemVisitStats(true);
    //     setIsItemClickStats(true);
    //     setIsTotalSpaceClicks(true);
    //     setIsAvatarClick(true);
    //     Axios.all([
    //         // AxiosAPI({
    //         //     method: 'post',
    //         //     url: `${gAPI_VisitorsGroups_Stats}`,
    //         //     data: {
    //         //         groupId: getGroupID(),
    //         //         propertyId: propertyId === "-1" ? null : propertyId,
    //         //         integrationId: integrationIdList,
    //         //         dateFrom: daysAgo90(),
    //         //         dateTo: today(),
    //         //     },
    //         // }).then((res) => {
    //         //     setVisitorVisitStatsData(res.data);
    //         //     setIsVisitorVisit(false);
    //         // }),
    //         AxiosAPI({
    //             method: 'get',
    //             url: `${gAPI_SpaceClick_DateWise_Stats}`,
    //             params: {
    //                 groupId: getGroupID(),
    //                 propertyId: propertyId,
    //                 dateFrom: daysAgo90(),
    //                 dateTo: today(),
    //             },
    //         }).then((res) => {
    //             setItemVisitStatsData(res.data);
    //             setIsItemVisitStats(false);
    //         }),
    //         AxiosAPI({
    //             method: 'get',
    //             url: `${gAPI_SpaceClick_Stats}`,
    //             params: {
    //                 groupId: getGroupID(),
    //                 propertyId: propertyId,
    //                 dateFrom: daysAgo90(),
    //                 dateTo: today(),
    //                 lang: "en"
    //             },
    //         }).then((res) => {
    //             setItemClickData(res.data);
    //             setIsItemClickStats(false);
    //             setIsTotalSpaceClicks(false);
    //         }),
    //         AxiosAPI({
    //             method: 'get',
    //             url: `${gAPI_SpaceAvatarClick_DateWise_Stats}`,
    //             params: {
    //                 groupId: getGroupID(),
    //                 propertyId: propertyId,
    //                 dateFrom: daysAgo90(),
    //                 dateTo: today(),
    //             },
    //         }).then((res) => {
    //             setAvatarClickData(res.data);
    //             setIsAvatarClick(false);
    //         }),
    //     ]);
    // };
    // const selectThisWeek = () => {
    //     setFilterDate(false);
    //     setButtonText(<IntlMessages id="dashboards.this-week" />);
    //     setLabels(week);
    //     setIsVisitorVisit(true);
    //     setIsItemVisitStats(true);
    //     setIsItemClickStats(true);
    //     setIsTotalSpaceClicks(true);
    //     setIsAvatarClick(true);
    //     Axios.all([
    //         // AxiosAPI({
    //         //     method: 'post',
    //         //     url: `${gAPI_VisitorsGroups_Stats}`,
    //         //     data: {
    //         //         groupId: getGroupID(),
    //         //         propertyId: propertyId === "-1" ? null : propertyId,
    //         //         integrationId: integrationIdList,
    //         //         dateFrom: startOfWeek(),
    //         //         dateTo: endOfWeek(),
    //         //     },
    //         // }).then((res) => {
    //         //     setVisitorVisitStatsData(res.data);
    //         //     setIsVisitorVisit(false);
    //         // }),
    //         AxiosAPI({
    //             method: 'get',
    //             url: `${gAPI_SpaceClick_DateWise_Stats}`,
    //             params: {
    //                 groupId: getGroupID(),
    //                 propertyId: propertyId,
    //                 dateFrom: startOfWeek(),
    //                 dateTo: endOfWeek(),
    //             },
    //         }).then((res) => {
    //             setItemVisitStatsData(res.data);
    //             setIsItemVisitStats(false);
    //         }),
    //         AxiosAPI({
    //             method: 'get',
    //             url: `${gAPI_SpaceClick_Stats}`,
    //             params: {
    //                 groupId: getGroupID(),
    //                 propertyId: propertyId,
    //                 dateFrom: startOfWeek(),
    //                 dateTo: endOfWeek(),
    //                 lang: "en"
    //             },
    //         }).then((res) => {
    //             setItemClickData(res.data);
    //             setIsItemClickStats(false);
    //             setIsTotalSpaceClicks(false);
    //         }),
    //         AxiosAPI({
    //             method: 'get',
    //             url: `${gAPI_SpaceAvatarClick_DateWise_Stats}`,
    //             params: {
    //                 groupId: getGroupID(),
    //                 propertyId: propertyId,
    //                 dateFrom: startOfWeek(),
    //                 dateTo: today(),
    //             },
    //         }).then((res) => {
    //             setAvatarClickData(res.data);
    //             setIsAvatarClick(false);
    //         }),
    //     ]);
    // };
    // const handleFilterDateWise = (startDate, endDate) => {
    //     setIsVisitorVisit(true);
    //     setIsItemVisitStats(true);
    //     setIsItemClickStats(true);
    //     setIsTotalSpaceClicks(true);
    //     setIsAvatarClick(true);

    //     Axios.all([
    //         // AxiosAPI({
    //         //     method: 'post',
    //         //     url: `${gAPI_VisitorsGroups_Stats}`,
    //         //     data: {
    //         //         groupId: getGroupID(),
    //         //         propertyId: propertyId === "-1" ? null : propertyId,
    //         //         integrationId: integrationIdList,
    //         //         dateFrom: startDate,
    //         //         dateTo: endDate,
    //         //     },
    //         // }).then((res) => {
    //         //     setVisitorVisitStatsData(res.data);
    //         //     setIsVisitorVisit(false);
    //         // }),
    //         AxiosAPI({
    //             method: 'get',
    //             url: `${gAPI_SpaceClick_DateWise_Stats}`,
    //             params: {
    //                 groupId: getGroupID(),
    //                 propertyId: propertyId,
    //                 dateFrom: startDate,
    //                 dateTo: endDate,
    //             },
    //         }).then((res) => {
    //             setItemVisitStatsData(res.data);
    //             setIsItemVisitStats(false);
    //         }),
    //         AxiosAPI({
    //             method: 'get',
    //             url: `${gAPI_SpaceClick_Stats}`,
    //             params: {
    //                 groupId: getGroupID(),
    //                 propertyId: propertyId,
    //                 dateFrom: startDate,
    //                 dateTo: endDate,
    //                 lang: "en"
    //             },
    //         }).then((res) => {
    //             setItemClickData(res.data);
    //             setIsItemClickStats(false);
    //             setIsTotalSpaceClicks(false);
    //         }),
    //         AxiosAPI({
    //             method: 'get',
    //             url: `${gAPI_SpaceAvatarClick_DateWise_Stats}`,
    //             params: {
    //                 groupId: getGroupID(),
    //                 propertyId: propertyId,
    //                 dateFrom: startDate,
    //                 dateTo: endDate,
    //             },
    //         }).then((res) => {
    //             setAvatarClickData(res.data);
    //             setIsAvatarClick(false);
    //         }),
    //     ]);
    // };
    // const selectThisMonth = () => {
    //     setButtonText(<IntlMessages id="dashboards.this-month" />);
    //     setLabels(month);
    //     setFilterDate(false);
    //     setIsVisitorVisit(true);
    //     setIsItemVisitStats(true);
    //     setIsItemClickStats(true);
    //     setIsTotalSpaceClicks(true);
    //     setIsAvatarClick(true);
    //     Axios.all([
    //         // AxiosAPI({
    //         //     method: 'post',
    //         //     url: `${gAPI_VisitorsGroups_Stats}`,
    //         //     data: {
    //         //         groupId: getGroupID(),
    //         //         propertyId: propertyId === "-1" ? null : propertyId,
    //         //         integrationId: integrationIdList,
    //         //         dateFrom: startOfMonth(),
    //         //         dateTo: endOfMonth(),
    //         //     },
    //         // }).then((res) => {
    //         //     setVisitorVisitStatsData(res.data);
    //         //     setIsVisitorVisit(false);
    //         // }),
    //         AxiosAPI({
    //             method: 'get',
    //             url: `${gAPI_SpaceClick_DateWise_Stats}`,
    //             params: {
    //                 groupId: getGroupID(),
    //                 propertyId: propertyId,
    //                 dateFrom: startOfMonth(),
    //                 dateTo: endOfMonth(),
    //             },
    //         }).then((res) => {
    //             setItemVisitStatsData(res.data);
    //             setIsItemVisitStats(false);
    //         }),
    //         AxiosAPI({
    //             method: 'get',
    //             url: `${gAPI_SpaceClick_Stats}`,
    //             params: {
    //                 groupId: getGroupID(),
    //                 propertyId: propertyId,
    //                 dateFrom: startOfMonth(),
    //                 dateTo: endOfMonth(),
    //                 lang: "en"
    //             },
    //         }).then((res) => {
    //             setItemClickData(res.data);
    //             setIsItemClickStats(false);
    //             setIsTotalSpaceClicks(false);
    //         }),
    //         AxiosAPI({
    //             method: 'get',
    //             url: `${gAPI_SpaceAvatarClick_DateWise_Stats}`,
    //             params: {
    //                 groupId: getGroupID(),
    //                 propertyId: propertyId,
    //                 dateFrom: startOfMonth(),
    //                 dateTo: endOfMonth(),
    //             },
    //         }).then((res) => {
    //             setAvatarClickData(res.data);
    //             setIsAvatarClick(false);
    //         }),
    //     ]);
    // };

    // const selectPreviousMonth = () => {
    //     setFilterDate(false);
    //     setButtonText(<IntlMessages id="dashboards.previous-month" />);
    //     setLabels(month);
    //     setIsVisitorVisit(true);
    //     setIsItemVisitStats(true);
    //     setIsItemClickStats(true);
    //     setIsTotalSpaceClicks(true);
    //     setIsAvatarClick(true);
    //     Axios.all([
    //         // AxiosAPI({
    //         //     method: 'post',
    //         //     url: `${gAPI_VisitorsGroups_Stats}`,
    //         //     data: {
    //         //         groupId: getGroupID(),
    //         //         propertyId: propertyId === "-1" ? null : propertyId,
    //         //         integrationId: integrationIdList,
    //         //         dateFrom: startOfPreviousMonth(),
    //         //         dateTo: endOfPreviousMonth(),
    //         //     },
    //         // }).then((res) => {
    //         //     setVisitorVisitStatsData(res.data);
    //         //     setIsVisitorVisit(false);
    //         // }),
    //         AxiosAPI({
    //             method: 'get',
    //             url: `${gAPI_SpaceClick_DateWise_Stats}`,
    //             params: {
    //                 groupId: getGroupID(),
    //                 propertyId: propertyId,
    //                 dateFrom: startOfPreviousMonth(),
    //                 dateTo: endOfPreviousMonth(),
    //             },
    //         }).then((res) => {
    //             setItemVisitStatsData(res.data);
    //             setIsItemVisitStats(false);
    //         }),
    //         AxiosAPI({
    //             method: 'get',
    //             url: `${gAPI_SpaceClick_Stats}`,
    //             params: {
    //                 groupId: getGroupID(),
    //                 propertyId: propertyId,
    //                 dateFrom: startOfPreviousMonth(),
    //                 dateTo: endOfPreviousMonth(),
    //                 lang: "en"
    //             },
    //         }).then((res) => {
    //             setItemClickData(res.data);
    //             setIsItemClickStats(false);
    //             setIsTotalSpaceClicks(false);
    //         }),
    //         AxiosAPI({
    //             method: 'get',
    //             url: `${gAPI_SpaceAvatarClick_DateWise_Stats}`,
    //             params: {
    //                 groupId: getGroupID(),
    //                 propertyId: propertyId,
    //                 dateFrom: startOfPreviousMonth(),
    //                 dateTo: endOfPreviousMonth(),
    //             },
    //         }).then((res) => {
    //             setAvatarClickData(res.data);
    //             setIsAvatarClick(false);
    //         }),
    //     ]);
    // };

    // const selectThisYear = () => {
    //     setButtonText(<IntlMessages id="dashboards.yeartodate" />);
    //     setLabels(year);
    //     setFilterDate(false);
    //     setIsVisitorVisit(true);
    //     setIsItemVisitStats(true);
    //     setIsItemClickStats(true);
    //     setIsTotalSpaceClicks(true);
    //     setIsAvatarClick(true);
    //     Axios.all([
    //         // AxiosAPI({
    //         //     method: 'post',
    //         //     url: `${gAPI_VisitorsGroupsMonth_Stats}`,
    //         //     data: {
    //         //         groupId: getGroupID(),
    //         //         propertyId: propertyId === "-1" ? null : propertyId,
    //         //         integrationId: integrationIdList,
    //         //         dateFrom: startOfThisYear(),
    //         //         dateTo: today(),
    //         //     },
    //         // }).then((res) => {
    //         //     setVisitorVisitStatsData(res.data);
    //         //     setIsVisitorVisit(false);
    //         // }),
    //         AxiosAPI({
    //             method: 'get',
    //             url: `${gAPI_SpaceClick_DateWise_Stats}`,
    //             params: {
    //                 groupId: getGroupID(),
    //                 propertyId: propertyId,
    //                 dateFrom: startOfThisYear(),
    //                 dateTo: today(),
    //             },
    //         }).then((res) => {
    //             setItemVisitStatsData(res.data);
    //             setIsItemVisitStats(false);
    //         }),
    //         AxiosAPI({
    //             method: 'get',
    //             url: `${gAPI_SpaceClick_Stats}`,
    //             params: {
    //                 groupId: getGroupID(),
    //                 propertyId: propertyId,
    //                 dateFrom: startOfThisYear(),
    //                 dateTo: today(),
    //                 lang: "en"
    //             },
    //         }).then((res) => {
    //             setItemClickData(res.data);
    //             setIsItemClickStats(false);
    //             setIsTotalSpaceClicks(false);
    //         }),
    //         AxiosAPI({
    //             method: 'get',
    //             url: `${gAPI_SpaceAvatarClick_DateWise_Stats}`,
    //             params: {
    //                 groupId: getGroupID(),
    //                 propertyId: propertyId,
    //                 dateFrom: startOfThisYear(),
    //                 dateTo: today(),
    //             },
    //         }).then((res) => {
    //             setAvatarClickData(res.data);
    //             setIsAvatarClick(false);
    //         }),
    //     ]);
    // };

    // const selectLastYear = () => {
    //     setFilterDate(false);
    //     setButtonText(<IntlMessages id="dashboards.lastyear" />);
    //     setLabels(year);
    //     setIsVisitorVisit(true);
    //     setIsItemVisitStats(true);
    //     setIsItemClickStats(true);
    //     setIsTotalSpaceClicks(true);
    //     setIsAvatarClick(true);

    //     Axios.all([
    //         // AxiosAPI({
    //         //     method: 'post',
    //         //     url: `${gAPI_VisitorsGroupsMonth_Stats}`,
    //         //     data: {
    //         //         groupId: getGroupID(),
    //         //         propertyId: propertyId === "-1" ? null : propertyId,
    //         //         integrationId: integrationIdList,
    //         //         dateFrom: startOfLastYear(),
    //         //         dateTo: endOfLastYear(),
    //         //     },
    //         // }).then((res) => {
    //         //     setVisitorVisitStatsData(res.data);
    //         //     setIsVisitorVisit(false);
    //         // }),
    //         AxiosAPI({
    //             method: 'get',
    //             url: `${gAPI_SpaceClick_DateWise_Stats}`,
    //             params: {
    //                 groupId: getGroupID(),
    //                 propertyId: propertyId,
    //                 dateFrom: startOfLastYear(),
    //                 dateTo: endOfLastYear(),
    //             },
    //         }).then((res) => {
    //             setItemVisitStatsData(res.data);
    //             setIsItemVisitStats(false);
    //         }),
    //         AxiosAPI({
    //             method: 'get',
    //             url: `${gAPI_SpaceClick_Stats}`,
    //             params: {
    //                 groupId: getGroupID(),
    //                 propertyId: propertyId,
    //                 dateFrom: startOfLastYear(),
    //                 dateTo: endOfLastYear(),
    //                 lang: "en"
    //             },
    //         }).then((res) => {
    //             setItemClickData(res.data);
    //             setIsItemClickStats(false);
    //             setIsTotalSpaceClicks(false);
    //         }),
    //         AxiosAPI({
    //             method: 'get',
    //             url: `${gAPI_SpaceAvatarClick_DateWise_Stats}`,
    //             params: {
    //                 groupId: getGroupID(),
    //                 propertyId: propertyId,
    //                 dateFrom: startOfLastYear(),
    //                 dateTo: endOfLastYear(),
    //             },
    //         }).then((res) => {
    //             setAvatarClickData(res.data);
    //             setIsAvatarClick(false);
    //         }),
    //     ]);
    // };


    // const handleFilterMonthWise = (startDate, endDate) => {
    //     setLabels(year);
    //     setIsVisitorVisit(true);
    //     setIsItemClickStats(true);
    //     setIsTotalSpaceClicks(true);
    //     setIsAvatarClick(true);
    //     Axios.all([
    //         // AxiosAPI({
    //         //     method: 'post',
    //         //     url: `${gAPI_VisitorsGroupsMonth_Stats}`,
    //         //     data: {
    //         //         groupId: getGroupID(),
    //         //         propertyId: propertyId === "-1" ? null : propertyId,
    //         //         integrationId: integrationIdList,
    //         //         dateFrom: startDate,
    //         //         dateTo: endDate,
    //         //     },
    //         // }).then((res) => {
    //         //     setVisitorVisitStatsData(res.data);
    //         //     setIsVisitorVisit(false);
    //         // }),
    //         AxiosAPI({
    //             method: 'get',
    //             url: `${gAPI_SpaceClick_DateWise_Stats}`,
    //             params: {
    //                 groupId: getGroupID(),
    //                 propertyId: propertyId,
    //                 dateFrom: startDate,
    //                 dateTo: endDate,
    //             },
    //         }).then((res) => {
    //             setItemVisitStatsData(res.data);
    //             setIsItemVisitStats(false);
    //         }),
    //         AxiosAPI({
    //             method: 'get',
    //             url: `${gAPI_SpaceClick_Stats}`,
    //             params: {
    //                 groupId: getGroupID(),
    //                 propertyId: propertyId,
    //                 dateFrom: startDate,
    //                 dateTo: endDate,
    //                 lang: "en"
    //             },
    //         }).then((res) => {
    //             setItemClickData(res.data);
    //             setIsItemClickStats(false);
    //             setIsTotalSpaceClicks(false);
    //         }),
    //         AxiosAPI({
    //             method: 'get',
    //             url: `${gAPI_SpaceAvatarClick_DateWise_Stats}`,
    //             params: {
    //                 groupId: getGroupID(),
    //                 propertyId: propertyId,
    //                 dateFrom: startDate,
    //                 dateTo: endDate,
    //             },
    //         }).then((res) => {
    //             setAvatarClickData(res.data);
    //             setIsAvatarClick(false);
    //         }),

    //     ]);
    // }
    const handleFilter = () => {
        let diff = endDate.diff(startDate, 'days');
        setButtonText('Date Range');
        if (diff > 365) {
            setMessage("The start and end date must be within a year of each other.");
            setError(true);
            return;
        }
        if (diff > 90) {
            setIsShow(false);
            setLabels(year);
            handleFilterMonthWise(moment(startDate).format('YYYY-MM-DD 00:00:00'), moment(endDate).format('YYYY-MM-DD') + ' 23:59:59');
            setFilterDate(true);

        } else {
            if (diff >= 60)
                setLabels(LastDays(startDate, endDate));
            else if (diff >= 30)
                setLabels(LastDays(startDate, endDate));
            else if (diff >= 7)
                setLabels(LastDays(startDate, endDate));
            else
                setLabels(LastDays(startDate, endDate));
            setIsShow(false);
            handleFilterDateWise(moment(startDate).format('YYYY-MM-DD 00:00:00'), moment(endDate).format('YYYY-MM-DD') + ' 23:59:59');
            setFilterDate(true);
        }
    };

    return (
        <Fragment>
            <Row>
                <Col xxs="12" className="mb-2">
                    <Fragment>
                        {filterDate === true && <div className='float-left mt-2'>
                            <span className='mr-2'><b>From : </b>{moment(startDate).format('DD')}/{moment(startDate).format('MM')}/{moment(startDate).format('YYYY')}</span>
                            <span className='ml-2'><b>To : </b>{moment(endDate).format('DD')}/{moment(endDate).format('MM')}/{moment(endDate).format('YYYY')}</span>
                        </div>}
                        <div className="btn-group float-right float-none-xs mb-3">
                            <UncontrolledDropdown>
                                <DropdownToggle
                                    caret
                                    color="primary"
                                    className="btn-xs"
                                    outline
                                >
                                    {buttonText}
                                </DropdownToggle>
                                <DropdownMenu right>
                                    <DropdownItem onClick={selectLast7Days}>
                                        <IntlMessages id="dashboards.last-7-days" />
                                    </DropdownItem>
                                    <DropdownItem onClick={selectLast30Days}>
                                        <IntlMessages id="dashboards.last-30-days" />
                                    </DropdownItem>
                                    <DropdownItem onClick={selectLast60Days}>
                                        <IntlMessages id="dashboards.last-60-days" />
                                    </DropdownItem>
                                    <DropdownItem onClick={selectLast90Days}>
                                        <IntlMessages id="dashboards.last-90-days" />
                                    </DropdownItem>
                                    <DropdownItem onClick={selectThisWeek}>
                                        <IntlMessages id="dashboards.this-week" />
                                    </DropdownItem>
                                    <DropdownItem onClick={selectThisMonth}>
                                        <IntlMessages id="dashboards.this-month" />
                                    </DropdownItem>
                                    <DropdownItem onClick={selectPreviousMonth}>
                                        <IntlMessages id="dashboards.previous-month" />
                                    </DropdownItem>
                                    <DropdownItem onClick={selectThisYear}>
                                        <IntlMessages id="dashboards.yeartodate" />
                                    </DropdownItem>
                                    <DropdownItem onClick={selectLastYear}>
                                        <IntlMessages id="dashboards.lastyear" />
                                    </DropdownItem>
                                    <DropdownItem onClick={() => setIsShow(!isShow)}>
                                        <IntlMessages id="form-components.date-range" />
                                    </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </div>
                    </Fragment>
                </Col>
            </Row>
            <Row>
                {/* <Col sm="12" md="6" className="mb-4">
                    {isVisitorVisit ? (
                        <div className="text-center">
                           <div className="text-center loading" />
                        </div>
                    ) : (
                        <VisitorVisitsChartCard
                            labels={labels}
                            visitorStatsData={visitorVisitStatsData}
                        />
                        // <p style={{ textAlign: 'center' }}>Temporarily Unavailable</p>
                    )}
                </Col> */}
                <Col sm="12" md="12" className="mb-4">
                    <StatContainer
                        error={itemClickStatsError}
                        isLoading={isItemClickStats}
                        onRefresh={() => fetchItemClickStats(fromDate, toDate)}
                    >
                        {isItemClickStats ? (
                            <div className="text-center">
                                <div className="text-center loading" />
                            </div>
                        ) : (
                            <NumberStats
                                data={itemClickData}
                            />
                        )}
                    </StatContainer>
                </Col>
                <Col sm="12" md="6" className="mb-4">
                    <StatContainer
                        error={itemVisitStatsError}
                        isLoading={isItemVisitStats}
                        onRefresh={() => fetchItemVisitStats(fromDate, toDate)}
                    >
                        {isItemVisitStats ? (
                            <div className="text-center">
                                <div className="text-center loading" />
                            </div>
                        ) : (
                            <ItemVisitsChartCard
                                labels={labels}
                                data={itemVisitStatsData}
                            />
                        )}
                    </StatContainer>
                </Col>
                <Col sm="12" md="6" className="mb-4">
                    <StatContainer
                        error={itemClickStatsError}
                        isLoading={isItemClickStats}
                        onRefresh={() => fetchItemClickStats(fromDate, toDate)}
                    >
                        {isItemClickStats ? (
                            <div className="text-center">
                                <div className="text-center loading" />
                            </div>
                        ) : (
                            <ItemClickStats
                                labels={dataTableSpaceStatsColumns}
                                data={itemClickData.itemClicks === null ? [] : itemClickData.itemClicks}
                            />
                        )}
                    </StatContainer>
                </Col>
            </Row>
            {/* <Row>
                <Col sm="12" md="12" className="mb-4">
                 <StatContainer
            error={avatarClickStatsError}
            isLoading={isAvatarClick}
            onRefresh={() => fetchAvatarClickStats(fromDate, toDate)}
        >
                    {isAvatarClick ? (
                        <div className="text-center">
                           <div className="text-center loading" />
                        </div>
                    ) : (
                        <AvatarClickStats
                            avatarlabel={avatarlabel}
                            data={avatarClickData}></AvatarClickStats>
                    )}
                            </StatContainer>
                </Col>
            </Row> */}

            <Modal isOpen={isShow}
                toggle={() => setIsShow(!isShow)} style={{ borderRadius: '10px' }}>
                <ModalHeader toggle={() => setIsShow(!isShow)}>
                    <IntlMessages id="form-components.date-range" />
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Colxx md="4" className="mb-2">
                            <FormGroup>
                                <Label><IntlMessages id='dashboards.start-date' /></Label>
                                <DatePicker
                                    style={{ borderRadius: "10px" }}
                                    selected={startDate ? new Date(startDate) : null} // ensure Date object
                                    onChange={handleStartDate}
                                    placeholderText="Start Date"
                                    dateFormat="dd/MM/yyyy"   // ✅ correct format
                                />
                            </FormGroup>
                        </Colxx>

                        <Colxx md="4" className="mb-2">
                            <FormGroup>
                                <Label> <IntlMessages id='dashboards.end-date' /></Label>
                                <DatePicker
                                    style={{ borderRadius: "10px" }}
                                    selected={endDate ? new Date(endDate) : null} // ✅ always Date object
                                    onChange={handleEndDate}
                                    placeholderText="End Date"
                                    dateFormat="dd/MM/yyyy"   // ✅ correct format
                                />
                            </FormGroup>
                        </Colxx>
                    </Row>

                </ModalBody>
                <ModalFooter>
                    <Button color='primary' onClick={() => handleFilter()}>Submit</Button>
                    <Button className="ml-2" onClick={() => setIsShow(!isShow)}>Close</Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={isError}
                toggle={() => setError(!isError)} style={{ borderRadius: '10px' }}>
                <ModalHeader toggle={() => setError(!isError)}>
                    BOOKMEBOB
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <p className='m-2'>{message}</p>
                    </Row>

                </ModalBody>
                <ModalFooter>
                    <Button className="ml-2" onClick={() => setError(!isError)}>Close</Button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
}